import {createStore, applyMiddleware, Store, compose} from "redux";
import createSagaMiddleware from "@redux-saga/core";
import logger from 'redux-logger';
import {appReducer} from "@fkhplus/common/src/modules/rootReducers";
import {rootSaga} from "@fkhplus/common/src/modules/rootSagas";

const configureStore = (): Store => {
    const sagaMiddleWare = createSagaMiddleware();
    const storeRedux = createStore(appReducer, compose(applyMiddleware(sagaMiddleWare, logger)));
    sagaMiddleWare.run(rootSaga);
    return storeRedux;
}
const store: Store = configureStore();
export default store;

